import { authClient, API } from '../index'

// Get all centers
export const getCenters = () => {
  return authClient().get(`${API}/center`)
}

// Get center by id
export const getCenterById = (id) => {
  return authClient().get(`${API}/center/${id}`)
}

// Delete center
export const deleteCenter = (id) => {
  return authClient().delete(`${API}/center/${id}`)
}

// Create center
export const postCenter = (center) => {
  return authClient().post(`${API}/center`, center)
}

// Update center
export const updateCenter = (id, center) => {
  return authClient().put(`${API}/center/${id}`, center)
}

export const changeStatusCenter = (id, active) => {
  return authClient().put(`${API}/center/change-status/${id}`, { active });
}